import styled from 'styled-components';
import * as colors from 'components/common/colorConstants';

export const LoadingHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  border-bottom: ${(props) => (props.showUnderline ? `0.1rem solid ${colors.lightGray11}` : 'none')};
`;
